export const WHATSAPP_NUMBER = "5551981779245";
export const WHATSAPP_DISPLAY = "(51) 98177-9245";
export const WHATSAPP_DEFAULT_MSG =
  "Olá! Conheci a Realiza Engenharia pelo site e gostaria de solicitar uma avaliação/orçamento.";
export const INSTAGRAM_HANDLE = "@realiza.predial";
export const INSTAGRAM_URL = "https://www.instagram.com/realiza.predial";
export const SITE_URL = "https://realizaengenhariapredial.com";
export const CREA = "CREA/RS 243524";

export const waLink = (msg = WHATSAPP_DEFAULT_MSG) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const NAV_ITEMS = [
  { label: "INÍCIO", href: "#inicio" },
  { label: "A REALIZA", href: "#a-realiza" },
  { label: "SERVIÇOS", href: "#servicos" },
  { label: "PROJETOS", href: "#projetos" },
  { label: "PLANO REALIZA", href: "#plano-realiza" },
  { label: "DIFERENCIAIS", href: "#diferenciais" },
  { label: "ORÇAMENTO", href: "#orcamento" },
  { label: "CONTATO", href: "#contato" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1486983493968-6550b6afbe96?crop=entropy&cs=srgb&fm=jpg&q=80&w=1920",
  aboutMain: "/images/about-equipe.jpg",
  techBg:
    "https://images.unsplash.com/photo-1786461717305-6f6eae288267?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
};
